module.exports = __webpack_public_path__ + "static/img/water8.1ba9971a.webp";